import Vue from 'vue';
import _ from 'lodash';
import Api from '../api/Api';

export default class ContactValidator {

    /**
     *
     * @param {Contact} contact
     */
    constructor(contact) {
        this.errors = {};

        this.contact = contact;
    }

    flushError(name) {
        Vue.set(this.errors, name, "");
    }

    validateSalutation() {
        this.flushError('salutation');

        if (!this.contact.salutation) {
            Vue.set(this.errors, 'salutation', 'page_setcontact.error.salutationmissing');
        }
    }

    validateFirstName () {
        this.flushError('firstname');

        if (!this.contact.firstname) {
            Vue.set(this.errors, 'firstname', 'page_setcontact.error.firstnamemissing');
        }
    }

    validateLastName() {
        this.flushError('lastname');

        if (!this.contact.lastname) {
            Vue.set(this.errors, 'lastname', 'page_setcontact.error.lastnamemissing');
        }
    }

    validateEmail() {
        this.flushError('email');
        // eslint-disable-next-line no-useless-escape
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!this.contact.email || !re.test(_.toLower(this.contact.email))) {
            Vue.set(this.errors, 'email', 'page_setcontact.error.emailmissing');
        }else{
            // validate email in the database
            let dupes =  Api.post(`/check/email`, {email: this.contact.email});
            dupes.then((response) => {
                if(!response.data.success){
                    Vue.set(this.errors, 'email', 'page_setcontact.error.emailalreadyexists');
                }
            });
        }

    }

    validatePhone() {
        this.flushError('phone');

        if(!this.contact.phone) {
            Vue.set(this.errors, 'phone', 'page_setcontact.error.phoneinvalid');
        } else {
            let parsed = window.parsePhoneNumberFromString(this.contact.phone);
            if(!parsed || !parsed.isValid()) {
                Vue.set(this.errors, 'phone', 'page_setcontact.error.phoneinvalid');
            }
        }
    }

    validateFax () {
        this.flushError('fax');

        if(this.contact.fax) {
            let parsed = window.parsePhoneNumberFromString(this.contact.fax);
            if(!parsed || !parsed.isValid()) {
                Vue.set(this.errors, 'fax', 'page_setcontact.error.faxinvalid');
            }
        }
    }

    validateAll() {
        this.validateSalutation();
        this.validateFirstName();
        this.validateLastName();
        this.validateEmail();
        this.validatePhone();
        this.validateFax();
    }
}